/* eslint-disable react-hooks/exhaustive-deps */
import Sider from 'antd/es/layout/Sider'
import { useContext, useEffect, useMemo, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { Button, ConfigProvider, Layout, Menu, Spin, MenuProps } from 'antd'
import {
  MenuOutlined,
  LogoutOutlined,
  UserSwitchOutlined
} from '@ant-design/icons'
import { Content, Header } from 'antd/es/layout/layout'
import Navigation from '@/layout/components/Navigation'
import { menuHandler } from '@/layout/utils/handle-menu'
import { generateMenu } from '@/layout/utils/menu-generator'
import PrivateWidget from '@/layout/components/PrivateWidget'
import { formatPrice } from '@/shared/components/mission-setting/utils/format-price'
import { QUERY_KEYS } from '@/features/farmer/domain/farmer-enum'
import { Farmer, Profile } from '@/features/farmer/domain/farmer-interface'
import { farmerLogoutService } from '@/features/farmer/application/farmer-service'
import { QUERY_KEYS as QUERY_KEYS_FINANCIAL_MANAGEMENT } from '@/features/financial-management/domain/financial-management.enum'
import {
  FinancialManagementRepository,
  FinancialManagementRepositoryImpl
} from '@/features/financial-management/data/repositories/financial-management-repositories'
import { WalletBalance } from '@/features/financial-management/domain/financial-management.interface'

import profileContext from '@/context/profileContext'
// @ts-ignore
import MainLogo from '@assets/icons/mainLogo.svg'
// @ts-ignore
import wallet from '@assets/images/dashboard/Payment/wallet.png'
// @ts-ignore
import AgroyaarLoading from '../../gif/Ripple-1s-200px.gif'

type MenuItem = Required<MenuProps>['items'][number]

interface DashboardLayoutProps {
  profile: Profile
}

const DashboardLayout = ({ profile }: DashboardLayoutProps) => {
  const navigate = useNavigate()
  const location = useLocation()
  const queryClient = useQueryClient()

  const width: number = useMemo(() => {
    return document.documentElement.clientWidth || window.innerWidth
  }, [])

  const menu: MenuItem[] = useMemo(
    () => generateMenu(profile.access) || [],
    [profile.access]
  )

  const [key, setKey] = useState<number>(1)

  const [menuItems, setMenuItems] = useState<MenuItem[]>([])
  const [selectedKeys, setSelectedKeys] = useState<string[]>([
    location.pathname
  ])
  const [openKeys, setOpenKeys] = useState<string[]>([])

  const [menuBoxsize, setMenuBoxsize] = useState<string>('25%')
  const [menuBoxStyle, setMenuBoxStyle] = useState<string>('max-lg:hidden')
  // برای ریسپانسیو
  const [miniLogout, setMiniLogout] = useState<boolean>(false)

  const [farmer, setFarmer] = useState<Farmer | null>(profile.farmer)
  // احتمالا برای تغییر نقش است
  // @ts-ignore
  const { farmerProfile, resetProfileContext } = useContext(profileContext)

  const logoutMutation = useMutation(farmerLogoutService, {
    onSuccess: () => {
      navigate('/login')
    }
  })

  function handleMenuItemClick (menuInfo: any) {
    navigate(menuInfo.key)
    if (menuBoxStyle === 'max-lg:hidden') {
      return setMenuBoxStyle('max-lg:block')
    } else {
      setMenuBoxStyle('max-lg:hidden')
    }
  }

  function handleOpenChange (openKeys: string[]) {
    setOpenKeys(openKeys)
  }

  function showMiniProfileDetailsInResponsive () {
    if (!localStorage.getItem('isExpert') && width > 1024) {
      navigate('/profile')
    }
    if (width <= 1024 && miniLogout === false) {
      setMiniLogout(true)
    } else if (width <= 1024 && miniLogout === true) {
      setMiniLogout(false)
    }
  }

  function logout () {
    logoutMutation.mutate()
  }

  // useEffect(() => {
  //   setKey(prev => prev + 1)

  //   if (profile) {
  //     resetProfileContext()
  //     queryClient.refetchQueries({ queryKey: [QUERY_KEYS.getProfile] })
  //     const newProfile = JSON.stringify(profile.farmer)
  //     if (newProfile) {
  //       // قبلا خارج از شرط بود
  //       localStorage.setItem('profile', newProfile)
  //       // بعدا بررسی کن که چرا از لوکال استوریج خونده شده در حالیکه دقیقا قبلش در لوکال ذخیره شده
  //       // چرا مستقیما از مقدار خونده نشده (اول نوشته شده بعد خونده شده از لوکال)
  //       try {
  //         setFarmer(JSON.parse(localStorage.getItem('profile')!))
  //       } catch {
  //         setFarmer(null)
  //       }
  //     }
  //   }
  // }, [profile, location.pathname, navigate])

  const financialManagementRepository: FinancialManagementRepository =
    useMemo(() => {
      return new FinancialManagementRepositoryImpl()
    }, [])

  const walletBalanceQuery = useQuery<WalletBalance | undefined>({
    queryKey: [QUERY_KEYS_FINANCIAL_MANAGEMENT.walletBalance],
    queryFn: financialManagementRepository._walletBalance,
    enabled: profile.access.some(acc => {
      return !!acc.children.find(({ name }) => name === 'INVOICES')
    })
  })

  useEffect(() => {
    // حتما چک شود با کدهای مستر
    // if (newAccess) {
    //     setMenuItem(recurcivemenuItem(profileQuery?.data?.access));
    // } else if (!newAccess && !menuItem) {
    //     setMenuItem(recurcivemenuItem(profileQuery?.data?.access));
    // }
    //   }, [newAccess, profileQuery.data, profileQuery?.data?.access]);

    setMenuItems(menu)
  }, [])

  useEffect(() => {
    // Update selected keys when the pathname changes
    setSelectedKeys([location.pathname])
  }, [location.pathname])

  return (
    <ConfigProvider direction='rtl'>
      <Layout
        key={key}
        className='w-[100vw] max-w-[1952px] h-[100vh] overflow-clip bg-[#EBF3FA]'
      >
        {/* header */}
        <Header className='flex w-[100vw] max-w-[1920px] z-[2] bg-transparent h-fit justify-center items-center px-4 !pt-4'>
          <div className='flex w-[100%] px-5 justify-between items-center header-shadow !rounded-br-none max-lg:!rounded-br-[10px]'>
            <MenuOutlined
              onMouseDown={() =>
                menuHandler(
                  menuBoxStyle,
                  setMenuBoxStyle,
                  menuBoxsize,
                  setMenuBoxsize
                )
              }
              className='hidden max-lg:block text-2xl text-[#01984D]'
            />
            <Link to='https://agroyaar.com/'>
              <section className='flex flex-row gap-5 max-lg:gap-1 items-center justify-center max-lg:hidden'>
                <img
                  src={MainLogo}
                  className='w-[60px] max-lg:h-[40px] '
                  alt='Logo'
                />
                <label className='text-[#00753bc2] cursor-pointer font-body font-extrabold text-[1.5rem]'>
                  اگـــرویــار
                </label>
              </section>
            </Link>
            <Link to='/'>
              <section className='flex-row gap-5 max-lg:gap-1 items-center justify-center max-lg:flex hidden'>
                <img
                  src={MainLogo}
                  className='w-[60px] max-lg:h-[40px]'
                  alt='Logo'
                />
                <label className='text-[#00753bc2] cursor-pointer font-body font-extrabold text-[0.8rem]'>
                  پیشخوان
                </label>
              </section>
            </Link>
            <section className=' flex flex-row h-full items-center font-body text-sm p-1 gap-3'>
              <img
                onClick={showMiniProfileDetailsInResponsive}
                className='circle-neo h-[65px] w-[65px] max-lg:w-[50px] max-lg:h-[50px] cursor-pointer'
                src={
                  farmerProfile
                    ? process.env.REACT_APP_ARVAN_S3_BASE_URL +
                      farmerProfile?.avatar
                    : process.env.REACT_APP_ARVAN_S3_BASE_URL + farmer?.avatar!
                }
                alt='avatar'
              />
              {/* responsive logic!!!! بعدا حتما اصلاح بشه */}
              {miniLogout && (
                <div
                  onMouseOutCapture={() => setMiniLogout(false)}
                  className='bg-white absolute p-2 rounded-lg left-4 top-20 !z-[9999] '
                >
                  {farmer && !farmerProfile && (
                    <p>
                      {farmer.farmerCode
                        ? farmer.firstName + ' ' + farmer.lastName
                        : 'کشاورز مهمان'}
                    </p>
                  )}
                  {farmerProfile && (
                    <p>
                      {farmer?.farmerCode
                        ? farmerProfile?.firstName +
                          ' ' +
                          farmerProfile?.lastName
                        : 'کشاورز مهمان'}
                    </p>
                  )}
                  <div className='flex flex-row'>
                    <Button
                      hidden={!localStorage.getItem('isExpert')}
                      onClick={() => {
                        navigate('/switchUser')
                        setMiniLogout(false)
                      }}
                      className='!outline-none !border-none'
                      icon={<UserSwitchOutlined />}
                    />

                    <Button
                      onClick={logout}
                      type='link'
                      danger
                      loading={logoutMutation.isLoading}
                      icon={<LogoutOutlined />}
                      className='w-1/3 font-body'
                    >
                      خروج
                    </Button>
                  </div>
                </div>
              )}

              <div key={key} className='flex flex-col fo gap-1 max-lg:hidden'>
                {farmer && !farmerProfile && (
                  <p>
                    {farmer.farmerCode
                      ? farmer?.firstName + ' ' + farmer?.lastName
                      : 'کشاورز مهمان'}
                  </p>
                )}

                {farmerProfile && (
                  <p>
                    {farmer?.farmerCode
                      ? farmerProfile?.firstName + ' ' + farmerProfile?.lastName
                      : 'کشاورز مهمان'}
                  </p>
                )}

                {farmer?.farmerCode && (
                  <div className='flex flex-row gap-2 justify-between '>
                    <label>کدکشاورزی:</label>
                    {farmer && (
                      <p className='tracking-wider'>{farmer.farmerCode}</p>
                    )}
                  </div>
                )}

                <div className='flex flex-row justify-between gap-2 w-[210px]'>
                  {
                    <PrivateWidget
                      access={profile?.access ?? []}
                      route={'INVOICES'}
                    >
                      <Button
                        onClick={() =>
                          navigate('/financial-management?tab=transaction')
                        }
                        className='!outline-none shadow-none !border-none text-agroyar flex flex-row gap-1 justify-end'
                      >
                        <img
                          className='w-5 h-5 -mr-4'
                          src={wallet}
                          alt='wallet'
                        />
                        {walletBalanceQuery?.isLoading ? (
                          <Spin size='small' />
                        ) : (
                          formatPrice(walletBalanceQuery?.data?.walletBalance)
                        )}{' '}
                        تومان
                      </Button>
                    </PrivateWidget>
                  }

                  <Button
                    hidden={!localStorage.getItem('isExpert')}
                    onClick={() => {
                      navigate('/switchUser')
                      setMiniLogout(false)
                    }}
                    className='!outline-none !border-none '
                    icon={<UserSwitchOutlined />}
                  ></Button>

                  <Button
                    onClick={logout}
                    type='link'
                    danger
                    loading={logoutMutation.isLoading}
                    icon={<LogoutOutlined />}
                    className='p-0 font-body'
                  >
                    خروج
                  </Button>
                </div>
              </div>
            </section>
          </div>
        </Header>

        {/* sidebar and main content */}
        <Layout hasSider className='max-w-[1920px]'>
          <Sider className={menuBoxStyle} width={menuBoxsize}>
            <div
              className={`bg-[#EBF3FA] h-full pb-4 px-4 ${
                openKeys.length && 'overflow-y-auto'
              }`}
            >
              <Menu
                key={key}
                selectedKeys={selectedKeys}
                openKeys={openKeys}
                className='text-[1rem] !border-none !box-shadow rounded-b-[15px] p-2 flex flex-col justify-between bg-[#E9F0F7] overflow-clip'
                onClick={handleMenuItemClick}
                onOpenChange={handleOpenChange}
                mode='inline'
                items={menuItems}
              ></Menu>
            </div>
          </Sider>
          <Content
            onLoad={() => {
              return (
                <div className='h-[100vh] mt-60 mr-96 text-8xl max-lg:'>
                  <img src={AgroyaarLoading} alt='fallback' />
                </div>
              )
            }}
            style={{
              textAlign: 'center',
              marginLeft: 'auto',
              marginRight: 'auto',
              height: '100%',
              overflowY: 'auto',
              overflowX: 'hidden',
              backgroundColor: '#EBF3FA'
            }}
            onError={() => {
              ;<div className='h-[100vh] mt-60 mr-96 text-8xl max-lg:'>
                <p>خطا در برقراری ارتباط با سرور</p>
              </div>
            }}
          >
            <Navigation profile={profile} />
          </Content>
        </Layout>
      </Layout>
    </ConfigProvider>
  )
}

export default DashboardLayout
